import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, IconButton, Collapse
} from '@mui/material';
import { Add, Edit, Delete, ExpandMore, ExpandLess } from '@mui/icons-material';
import UserGuideForm from './UserGuideForm';
import UserGuideSections from './UserGuideSections';
import axios from 'axios';

import { User_Guide_Api } from '../../config/api/UserGuide';
import useUserGuideList from '../../hooks/user-guide/useUserGuideList';

const API_URL = 'https://yourapi.com/api/userguide';

export default function UserGuideList() {
//   const [guides, setGuides] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [editData, setEditData] = useState(null);

  const{guides,
         selectedGuide,
         selectedGuidID,
         setSelectedGuide,
         setSelectedGuideID,
        loadWarehouseByID,
        fetchUserGuideListByID,
        guidesByID, 
        setGuidesByID}= useUserGuideList(null);

//   useEffect(() => {
//     loadWarehouseByID(null);
//   }, []);

  const fetchGuides = async () => {
    // const res = await axios.get(User_Guide_Api.user_guide_crud.list);
    // setGuides(res.data);
    loadWarehouseByID(null);
  };

  const handleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDelete = async (id) => {
    // await axios.delete(`${API_URL}/${id}`);
    // fetchGuides();
  };

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>User Guides</Typography>
      <Button startIcon={<Add />} variant="contained" onClick={() => setOpenForm(true)}>Add Guide</Button>
      
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Module</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {guides.map((g) => (
              <React.Fragment key={g.user_guide_id}>
                <TableRow hover>
                  <TableCell>{g.title}</TableCell>
                  <TableCell>{g.version_no}</TableCell>
                  <TableCell>{g.module_name}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleExpand(g.user_guide_id)}>
                      {expanded[g.user_guide_id] ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                    <IconButton onClick={() => { setEditData(g); setOpenForm(true); }}><Edit /></IconButton>
                    <IconButton onClick={() => handleDelete(g.user_guide_id)}><Delete /></IconButton>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={4} sx={{ p: 0 }}>
                    <Collapse in={expanded[g.user_guide_id]} timeout="auto" unmountOnExit>
                      <UserGuideSections userGuideId={g.user_guide_id} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <UserGuideForm
        open={openForm}
        onClose={() => { setOpenForm(false); setEditData(null); }}
        editData={editData}
        onSave={fetchGuides}
      />
    </Box>
  );
}
